import { IAdminFlight } from '../../../../../../../store/admin/eventFlights/store';

export const isFlightInvalid = (
  flight: Partial<IAdminFlight>,
  setByAge: boolean,
  setByHandicap: boolean,
  automaticHandicaps: boolean
) =>
  flight.name === '' ||
  (setByAge && !flight.ageLower && !flight.ageUpper) ||
  (setByHandicap && !automaticHandicaps && !flight.handicapLower && !flight.handicapUpper);
